export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Dashboard",
        to: "/dashboard",
        icon: "cil-speedometer",
      },
      {
        _name: "CSidebarNavItem",
        name: "Subscription",
        to: "/subscription",
        icon: "cil-speedometer",
      },
      {
        _name: "CSidebarNavItem",
        name: "Transaction Files",
        to: "/telecel-transaction-files",
        icon: "cil-speedometer",
      },
      {
        _name: "CSidebarNavItem",
        name: "Loans Applications",
        to: "/loans",
        icon: "cil-chart-pie",
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Accounts",
        to: "/accounts",
        icon: "cil-user",
        items: [
          {
            name: "Staff",
            to: "/profiles/staff",
          },
          {
            name: "Personal",
            to: "/profiles/personal",
          },
          {
            name: "Business",
            to: "/profiles/Business",
          },
        ],
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Credit',
      //   to: '/credit',
      //   icon: 'cil-chart-pie'
      // },
      {
        _name: "CSidebarNavDropdown",
        name: "Products",
        to: "/products",
        icon: "cil-puzzle",
        items: [
          {
            name: "Savings",
            to: "/products/Savingsproduct",
          },
          {
            name: "Loans",
            to: "/products/Loansproduct",
          },
        ],
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Cards',
      //   to: '/cards/card',
      //   icon: 'cil-pencil'
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Inventory',
      //   to: '/inventory',
      //   icon: 'cil-puzzle',
      //   items: [
      //     {
      //       name: 'Category',
      //       to: '/inventory/Category'
      //     },
      //     {
      //       name: 'Products Group',
      //       to: '/inventory/Productgroup'
      //     },
      //     {
      //       name: 'Items',
      //       to: '/inventory/Items'
      //     }

      //   ]

      // },
      {
        _name: "CSidebarNavDropdown",
        name: "Financial Activity",
        route: "/notifications",
        icon: "cil-bell",
        items: [
          {
            name: "Ledgers",
            to: "/financial/ledgers",
          },
          {
            name: "Momo Acounts",
            to: "/financial/transactions",
          },
        ],
      },
      {
        _name: "CSidebarNavItem",
        name: "Reports",
        to: "/reports",
        icon: "cil-chart-pie",
      },
      {
        _name: "CSidebarNavItem",
        name: "Messages",
        to: "/messages",
        icon: "cil-chart-pie",
      },

      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Notifications',
      //   route: '/notifications',
      //   icon: 'cil-bell',
      //   items: [
      //     {
      //       name: 'Alerts',
      //       to: '/notifications/alerts'
      //     },
      //     {
      //       name: 'Badges',
      //       to: '/notifications/badges'
      //     },
      //     {
      //       name: 'Modals',
      //       to: '/notifications/modals'
      //     }
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Widgets',
      //   to: '/widgets',
      //   icon: 'cil-calculator',
      //   badge: {
      //     color: 'primary',
      //     text: 'NEW',
      //     shape: 'pill'
      //   }
      // },
    ],
  },
];
